import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  inject,
} from '@angular/core';
import { SpinnerOverlayService } from './spinner-overlay.service';
import { map, startWith, tap } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';

export const GENERIC_SPINNER_TITLE = 'Processing... please wait';

@Component({
  selector: 'app-spinner-overlay',
  templateUrl: './spinner-overlay.component.html',
  styleUrls: ['../../../assets/css/spinner-overlay.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe],
})
export class SpinnerOverlayComponent {
  private readonly spinnerService = inject(SpinnerOverlayService);

  public isCryptoPayment: boolean = false;

  title = this.spinnerService.spinningEvents.pipe(
    tap(spinningEvent => {
      this.isCryptoPayment = spinningEvent.isCryptoPayment;
      if (spinningEvent.isCryptoPayment) {
        spinningEvent.title = 'Processing your crypto payment... please wait.';
      }
      this.hidden = !spinningEvent.spinning;
      if (this.hidden) {
        this.spinnerService.noSpinnerEvent$.next(true);
      }
    }),
    map(spinningEvent => spinningEvent.title),
    map(title => title || GENERIC_SPINNER_TITLE),
    startWith(GENERIC_SPINNER_TITLE)
  );

  @HostBinding('class.hidden') hidden = true;

  public cancelCryptoPayment() {
    this.spinnerService.cancelCryptoPayment.next(true);
  }
}
